import { z } from 'zod';
import type { TenantId } from '@/modules/tenant/domain/entities/tenant-ids';
import {
  AnswerOptionSchema,
  type Answers,
} from '@/modules/simulado/domain/entities/answer.entity';

export interface GabaritoDraft {
  answers: Answers;
}

const EMPTY: GabaritoDraft = { answers: {} };

/**
 * Rascunho de quando havia escolha de modo ainda traz `mode`: o `z.object`
 * descarta a chave a mais, e as respostas seguem valendo.
 */
const GabaritoDraftSchema = z.object({
  answers: z.record(z.coerce.number(), AnswerOptionSchema),
});

/**
 * O gabarito em preenchimento, no `localStorage` — o `GabaritoDraftStore` do
 * `enamed-feedback-lp`: **preencher não exige conta, enviar exige**, e entre a
 * última questão e o fim do login há um formulário inteiro. Some quando o
 * gabarito chega ao servidor.
 *
 * Chave com prova e ano, pelo mesmo motivo do rascunho do ensaio.
 */
export class GabaritoDraftStore {
  private readonly key: string;

  constructor(tenant: TenantId, year: number) {
    this.key = `exams-capture-lp:${tenant}:${year}:gabarito`;
  }

  read(): GabaritoDraft {
    try {
      const raw = localStorage.getItem(this.key);
      return raw ? GabaritoDraftSchema.parse(JSON.parse(raw)) : EMPTY;
    } catch {
      return EMPTY;
    }
  }

  save(draft: GabaritoDraft): void {
    try {
      localStorage.setItem(this.key, JSON.stringify(draft));
    } catch {
      // Sem espaço ou sem permissão. O preenchimento segue em memória.
    }
  }

  clear(): void {
    try {
      localStorage.removeItem(this.key);
    } catch {
      // Idem.
    }
  }
}
